import React from 'react';
import ZsFormikDatePicker from "src/components/atoms/zsDatePicker";
import {validate} from "src/utils/yup";
import * as Yup from "yup";

export interface IGasMeterReadingDateProps {
}

export function GasMeterReadingDate(props: IGasMeterReadingDateProps) {

    const getMinDate = () => {
      const d = new Date(new Date().toDateString());
        d.setDate(d.getDate() - 41);
        return d;
    }

    return (
        <>
            <label><span
                style={{color: '#F00'}}>*</span> Ablesedatum Gas</label>
            <ZsFormikDatePicker name="gasMeterReadingDate"
                                validate={validate(Yup.date().typeError('Bitte gültiges Datum eingeben.')
                                    .max(new Date(), 'Datum darf nicht in der Zukunft liegen.')
                                    .min(getMinDate(), 'Datum darf nicht länger als 42 Tage in der Vergangenheit liegen.')
                                    .required("Bitte das Ablesedatum angeben."))}
                                required/>
        </>
    );

}